<template>
	<div class="father-module flex flex-v">
		<div class="title-module flex flex-align-center flex-pack-justify">
			<img src="@/assets/image/layout/mod-title.png" alt="" class="title-module-img" />
			<div>传感器列表</div>
			<span class="num">总计：{{ tableData.length }}</span>
			<a href="javascript:;" class="more" @click="chiCeClick">查看更多</a>
		</div>
		<div class="main flex-1">
			<div class="mainTable" style="height: 100%">
				<el-table height="100%" ref="singleTable"  @current-change="rowClick" highlight-current-row v-loading="tableLoading" :data="tableData">
					<el-table-column align="center" type="index" width="50px" label="编号"></el-table-column>
					<el-table-column align="left" prop="equipmentAnotherName" label="传感器">
						<template #default="scope">
							<div class="sheng-lue" :title="scope.row.equipmentAnotherName">{{ scope.row.equipmentAnotherName }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" type="index" width="60px" label="操作">
						<template #default="scope">
							<img src="@/assets/image/layout/arrow.png" alt="" />
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="leftTop">
			<div class="eqType">
				<div
					class="flex align-center list"
					style="position: relative"
					v-for="(item, index) in typeList"
					:key="index"
					:class="{ active: eqPicNum == index }"
					@click="getPic(item.equipmentTypeUuid, index)"
				>
					<!-- <img style="width: 14px;height: 19px;color: #03434f;" src="@/assets/image/tubiao_画板 1.svg" alt="" v-if="eqPicNum == index" /> -->
					<div class="flex-1" style="min-width: 0; white-space: nowrap; text-overflow: ellipsis">{{ item.equipmentTypeName }}</div>
					<i></i>
				</div>
			</div>
			<div class="eqPic" v-show="flagPic">
				<i class="el-icon-caret-top san-jiao"></i>
				<el-image :src="eqPic" :preview-src-list="[eqPic]"></el-image>
			</div>
			<div v-show="yuJingShow" class="yu-jing">
				<i class="el-icon-caret-top yj-san-jiao"></i>
				<div class="yj-title">
					<div>预警值设置</div>
					<div class="que-ding">确定</div>
				</div>
				<div class="add"><i class="el-icon-plus"></i></div>
			</div>
		</div>
	</div>
</template>

<script>
import { EleResize } from '@/utils/resize.js';

export default {
	name: 'rightTop',
	props: ['tableData', 'typeList', 'echartData', 'tableLoading'],
	data() {
		return {
			down: false,
			input: '',
			chatr: null,
			chatrOption: null,
			// tableData: [],
			// ykj
			// typeList: [],
			eqPic: '',
			flagPic: false,
			eqPicNum: '0',
			yuJingShow: false,
			equipmentTypeUuid: ''
		};
	},
	watch: {
		echartData(newdata, olddata) {
			console.log('newdata', newdata);
			if (newdata) {
				// this.initCharts();
			}
		},
		$route(to, from) {
			this.bridgeObj = this.facList.find(i => {
				return i.bridgeUuid == this.$route.params.id;
			});
		}
	},
	components: {},
	methods: {
		//获取传感器布置图
		getPic(equipmentTypeUuid, index) {
			// console.log(equipmentTypeUuid, index);
			this.$emit('sheShiClick', equipmentTypeUuid);
			this.equipmentTypeUuid = equipmentTypeUuid;
			this.eqPicNum = index;
			this.flagPic = false;
			// this.flagPic = true
			this.$forceUpdate();
		},
		// 布置图
		async buZhiClick() {
			this.flagPic = this.flagPic ? false : true;
			const res = await this.$api.sendGet('/biBridge/getBridgeEquipmentTypePicture', {
				bridgeUuid: this.$route.params.id,
				equipmentTypeUuid: this.equipmentTypeUuid
			});
			console.log('布置图', res);
			this.eqPic = res.data ? res.data.equipmentTypePictureUrl : '';
		},
		// 实测数据
		chiCeClick() {
			this.$router.push('/home/shiceshuju');
		},
		// 表格点击
		rowClick(row) {
			console.log(row);
			this.$emit('gitxuanzhong', row.equipmentName);
		},
		// 下拉
		downClick() {
			this.down = !this.down;
			if (!this.down) {
				this.tableData = [
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' }
				];
			} else {
				this.tableData = [
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' },
					{ bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '22' }
					// {bianhao: '1', leixing: '振弦', chuanganqi: 'YB-01-01', zhi: '2222.22',},
				];
			}
		},
		// initCharts(xData, yData) {
		//   this.chatr = this.$echarts.init(document.getElementById('cgqmgt'));
		//   this.setOption(xData, yData)
		// },

		initCharts() {
			console.log(112, this.echartData);
			let myChart = this.$echarts.init(document.getElementById('cgqmgt'));
			let dom = document.getElementById('cgqmgt');
			EleResize.on(dom, myChart.resize);
			myChart.setOption({
				legend: {
					show: false
				},
				tooltip: {},
				series: [
					{
						type: 'pie',
						radius: [30, 70],
						center: ['50%', '50%'],
						roseType: 'area',
						itemStyle: {
							margin: 10,
							borderRadius: 0
						},
						data: this.echartData
						// data: [
						//   { value: 60, name: "振弦1" },
						//   { value: 38, name: "振弦2" },
						//   { value: 32, name: "振弦3" },
						//   { value: 30, name: "振弦4" },
						//   { value: 50, name: "振弦5" },
						// ],
					}
				]
			});
			// this.chatrOption = {

			// }
			// this.chatr.setOption(this.chatrOption);
			// this.chatr.resize();
		},
		setCurrent(name) {
			let row=this.tableData.find(item=>item.equipmentAnotherName==name)
			this.$refs.singleTable.setCurrentRow(row);
		}
	},
	computed: {
		// getStyle() {
		//   if (this.down === true) {
		//     return {
		//       height: '250px',
		//     }
		//   } else {
		//     return {
		//       height: '150px',
		//     }
		//   }
		// },
	},

	created() {},
	async mounted() {
		// this.initCharts();
		// console.log('this.echartData', this.echartData);
		// await this.getEqType();
		// await this.postChuan()
	},
	beforeDestroy() {},
	destroyed() {}
};
</script>

<style lang="scss" scoped>
.father-module .title-module .more {
	margin-top: 0;
}
.father-module {
	/deep/ .el-table__header-wrapper {
		border: 1px solid #0270ad;
		background: linear-gradient(265deg, rgba(1, 153, 239, 0.5) 0%, rgba(1, 63, 134, 0.5) 100%);
		line-height: 50px;
	}
	::v-deep .el-table__body tr {
		cursor: pointer;
	}
	::v-deep .el-table__body tr.current-row > td {
		color: #fff;
		background: rgba(255, 255, 255, 0.5) !important;
	}
}
.main {
	width: 100%;
	height: calc(100% - 45px);
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: 15px;
	box-sizing: border-box;

	.mainTable {
		width: 100%;
		.bottom {
			width: 20px;
			height: 20px;
			background: url('../../../assets/image/7592b2854bad5abc9c6d9dce2569989.png') no-repeat;
			background-size: 100% 100%;
			margin: 0 auto;
		}

		.top {
			width: 20px;
			height: 20px;
			background: url('../../../assets/image/a149b482fe552c4d1bb79eaefe047d7.png') no-repeat;
			background-size: 100% 100%;
			margin: 0 auto;
		}
	}

	/deep/ .el-table .el-table__cell {
		padding: 4px 0 !important;
	}

	/deep/ .el-table th.el-table__cell {
		background-color: rgba(0, 0, 0, 0) !important;
		border-bottom: 1px solid rgba(0, 0, 0, 0) !important;
	}

	/deep/ .el-table tr {
		background-color: rgba(0, 0, 0, 0) !important;
	}

	/deep/ .el-table tbody tr:hover > td {
		background-color: rgba(0, 0, 0, 0) !important;
	}

	/deep/ .el-table,
	.el-table__expanded-cell {
		background-color: rgba(0, 0, 0, 0) !important;
	}

	/deep/ .el-table td.el-table__cell {
		border-bottom: 1px solid rgba(0, 0, 0, 0) !important;
	}

	/deep/ .el-table th.el-table__cell > .cell {
		font-size: 18px;
		color: #ffffff;
		line-height: 20px;
		font-weight: 500;
	}

	/deep/ .el-table .cell {
		font-size: 16px;
		color: #ffffff;
	}

	/deep/ .el-table--border::after,
	.el-table--group::after,
	.el-table::before {
		background-color: rgba(0, 0, 0, 0) !important;
	}

	.cgqmgt {
		width: 100%;
		height: 230px;
	}
}
.sheng-lue {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.leftTop {
	width: 100%;
	// height: 100%;
	padding: 20px;
	box-sizing: border-box;

	.title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		height: 30px;
		color: #ffffff;

		.titL {
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		.titR {
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		.titleIcon {
			width: 20px;
			height: 20px;
		}

		.titleMian {
			margin-left: 10px;
			color: #ffffff;
			line-height: 30px;
			font-size: 18px;
		}

		.title3 {
			margin-left: 10px;
		}

		.titRInput {
			width: 65px;
			height: 24px;
		}

		/deep/ .titRInput .el-input__inner {
			height: 24px;
			padding: 0 0 0 10px;
			border: 1px solid #8ebdff;
			background: #234289;
			font-size: 16px;
			color: #ffffff;
			line-height: 24px;
		}
	}
}
.mainTable {
	::v-deep {
		.el-table__body-wrapper::-webkit-scrollbar {
			/*width: 0;宽度为0隐藏*/
			width: 2px;
			height: 5px;
		}
		.el-table__body-wrapper::-webkit-scrollbar-thumb {
			background: #94a4c9;
			border-radius: 4px;
		}
		.el-table__body-wrapper::-webkit-scrollbar-track {
			box-shadow: inset 0 0 5px rgba(241, 240, 245, 0.2);
			border-radius: 3px;
			height: 10px;
			background: rgba(0, 0, 0, 0.16);
			border-radius: 1px;
		}
		.el-table__body-wrapper .el-table__body {
			width: 100% !important;
		}
	}
	::v-deep .el-table tr.hover-row > td.el-table__cell,
	::v-deep .el-table tr.current-row > td.el-table__cell {
		background: rgba(255, 255, 255, 0.2) !important;
	}
}
.eqType {
	position: absolute;
	right: 400px;
	top: 17px;
	// top: 138px;
	.list {
		// width: 130px;
		// height: 40px;
		// margin-bottom: 30px;
		// line-height: 40px;
		// text-shadow: 0px 8px 20px rgba(0, 7, 26, 0.2);
		// color: white;
		// background: url('~@/assets/image/titleNew.png') no-repeat;
		// background-size: 100% 100%;
		width: 120px;
		height: 40px;
		background: linear-gradient(90deg, #104abd 0%, #0a2459 100%), linear-gradient(90deg, #0ee2de 0%, rgba(26, 45, 111, 0) 100%);
		border-radius: 8px 0px 0px 8px;
		color: #fff;
		font-size: 14px;
		line-height: 40px;

		text-align: left;
		cursor: pointer;
		border: 1px solid transparent;
		background-origin: border-box;
		background-clip: content-box, border-box;
		// img {
		// 	position: absolute;
		// 	right: -20px;
		// 	margin-top: 10px;
		// }
		i {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			right: 2px;
			display: block;
			height: 0;
			width: 0;
			border: 6px solid transparent;
			border-left-color: #fff;
			opacity: 0;
		}
		&.active {
			background: linear-gradient(90deg, #1e6dbc 0%, #013193 100%), linear-gradient(90deg, #0ee2de 0%, rgba(26, 45, 111, 0) 100%);
			background-origin: border-box;
			background-clip: content-box, border-box;
			i {
				opacity: 1;
			}
		}
		& > div {
			padding-left: 10px;
			padding-right: 26px;
		}
	}
}
.eqPic {
	position: absolute;
	z-index: 2;
	// top: 138px;
	top: 60px;
	// left: 450px;
	right: 10px;
	width: 240px;
	height: 180px;
	background: #fff;
	// color: #000;
	// background: rgba(21, 55, 135, 0.9);
	box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	border-radius: 4px;
	backdrop-filter: blur(2px);
	box-sizing: border-box;
	padding: 15px;
	font-size: 18px;
	color: white;
	text-align: left;
	.san-jiao {
		font-size: 30px;
		position: absolute;
		top: -20px;
		right: 30px;
	}
	img {
		height: 20px;
		width: 20px;
		vertical-align: text-bottom;
	}
	::v-deep .el-image {
		width: 210px;
		height: 96px;
		margin-top: 21px;
	}
}
.yu-jing {
	position: absolute;
	z-index: 2;
	// top: 138px;
	top: 60px;
	// left: 450px;
	right: 20px;
	width: 240px;
	height: 180px;
	background: #fff;
	.yj-san-jiao {
		font-size: 30px;
		position: absolute;
		top: -20px;
		color: #fff;
		right: 10px;
	}
	.yj-title {
		width: 90%;
		margin: 10px auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.que-ding {
			font-size: 14px;
			font-weight: 400;
			color: #11528b;
		}
	}
	.add {
		position: absolute;
		bottom: 10px;
		left: 5%;
		width: 90%;
		padding: 10px 0;
		border-radius: 4px;
		border: 1px dashed#dddddd;
	}
}
</style>
